import React from 'react';

import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { Table, Row, Col, Skeleton } from 'fpay-ui';

import { Menu } from 'components/Menu';

const StyledRow = styled(Row)`
  > div {
    height: inherit;
    font-size: 14px;
    align-items: center;
    display: flex;
    justify-content: space-between;
  }
`;

const StyledSkeleton = styled(Skeleton)`
  height: 16px;
  ${({ width }) => width && `width: ${width}px`}
`;

export const SkeletonLoader = () => {
  const { t } = useTranslation();

  return (
    <Table>
      <StyledRow header>
        <Col header>{t('reportsScreen.table.headers.date')}</Col>
        <Col header>{t('reportsScreen.table.headers.period')}</Col>
        <Col header>{t('reportsScreen.table.headers.type')}</Col>
        {/* <Col header>{t('reportsScreen.table.headers.reportNumber')}</Col>  */}
        <Col header>{t('reportsScreen.table.headers.state')}</Col>
      </StyledRow>
      {[...Array(10)].map((_, i) => (
        <StyledRow key={i}>
          <Col>
            <StyledSkeleton width={40} />
          </Col>
          <Col>
            <StyledSkeleton width={163} />
          </Col>
          <Col>
            <StyledSkeleton width={96} />
          </Col>
          {/* <Col>
            <StyledSkeleton width={84} />
          </Col> */}
          <Col>
            <StyledSkeleton width={68} />
            <Menu
              icon="ic_menu_dots.svg"
              data-testid="dots-icon"
              disabled
              style={{ pointerEvents: 'none', alignContent: 'center' }}
              imageStyle={{ height: '18px' }}
            />
          </Col>
        </StyledRow>
      ))}
    </Table>
  );
};
